module.exports = __webpack_public_path__ + "img/IMG_1699_Wood.af335d0b.jpg";